import { CircularProgress } from '@mui/material';
import React from 'react';

export default function EditForm({ handleEdit, formData, handleChange, handleFileChange, loading, fields, imgPreview }) {
    return (
        <div>
            <form onSubmit={handleEdit}>
                {fields.map(({ label, name, type, required, options }) => (
                    <div key={name} style={{ marginBottom: "10px" }}>
                        <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
                            {label}
                        </label>
                        {name === "officeId" ? (
                            <select
                                name={name}
                                value={
                                  typeof formData[name] === "object"
                                    ? formData[name]?._id || ""
                                    : formData[name] || ""
                                }
                                onChange={handleChange}
                                required={required}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    fontSize: "14px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                <option value="">Select an option</option>
                                {options?.map((option) => (
                                    <option key={option._id} value={option._id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        ) : name === "deptId" ? (
                            <select
                                name={name}
                                value={formData[name]}
                                onChange={handleChange}
                                required={required}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    fontSize: "14px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                <option value="" disabled>Select an option</option>
                                {options?.map((option) => (
                                    <option key={option.deptId} value={String(option.deptId)}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        ) : name === "facultyId" ? (
                            <select
                                name={name}
                                value={formData[name]}
                                onChange={handleChange}
                                required={required}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    fontSize: "14px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                <option value="" disabled>Select an option</option>
                                {options?.map((option) => (
                                    <option key={option.facultyId} value={String(option.facultyId)}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        ) : name === "deanOfFacultyId" ? (
                            <select
                                name={name}
                                value={formData[name] || ""}
                                onChange={handleChange}
                                required={required}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    fontSize: "14px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                <option value="">Not a Dean</option>
                                {options?.map((option) => (
                                    <option key={option.facultyId} value={String(option.facultyId)}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        ) : type === "textarea" ? (
                            <textarea
                                name={name}
                                value={formData[name] || ""}
                                onChange={handleChange}
                                required={required}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    fontSize: "14px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    height: "100px",
                                }}
                            />
                        ) : type === "dropdown" ? (
                            <select
                                name={name}
                                value={formData[name] || ""}
                                onChange={handleChange}
                                required={required}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    fontSize: "14px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                <option value="">Select an option</option>
                                {formData[name] &&
                                  options &&
                                  !options.includes(formData[name]) && (
                                    <option value={formData[name]}>
                                        {formData[name]}
                                    </option>
                                )}
                                {options?.map((option) => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            <input
                                type={type}
                                name={name}
                                value={formData[name]}
                                onChange={handleChange}
                                required={required}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    fontSize: "14px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                }}
                            />
                        )}
                    </div>
                ))}
                <div style={{ marginBottom: "10px" }}>
                    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
                        Upload Image
                    </label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        name="profileimg"
                        style={{
                            width: "100%",
                            padding: "8px",
                            fontSize: "14px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                        }}
                    />
                    {imgPreview && (
                        <img
                            src={imgPreview}
                            alt="Preview"
                            style={{ width: "30%", height: "auto", marginBottom: "15px" }}
                        />
                    )}
                </div>
                <div style={{ marginBottom: "10px" }}>
                    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
                        Resume
                    </label>
                    <input
                        type="file"
                        accept="pdf/*"
                        onChange={handleFileChange}
                        name="resume"
                        style={{
                            width: "100%",
                            padding: "8px",
                            fontSize: "14px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                        }}
                    />
                </div>
                <div style={{ marginBottom: "10px" }}>
                    <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
                        Head of Department
                    </label>
                    <input
                        type="checkbox"
                        name="hod"
                        checked={formData.hod}
                        onChange={handleChange}
                        style={{ transform: "scale(1.2)" }}
                    />
                </div>
                <button
                    type="submit"
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#4CAF50",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        marginTop: "10px",
                    }}
                >
                    {loading ? <CircularProgress size={24} color="inherit" /> : "Update"}
                </button>
            </form>
        </div>
    );
}